export default __webpack_public_path__ + "static/assets/454da9ee9a413870eb7eedd84c936daf.png";